import { render, staticRenderFns } from "./GWT.vue?vue&type=template&id=8c0d8176"
import script from "./GWT.vue?vue&type=script&lang=js"
export * from "./GWT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports